import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Organization, UpdateOrganizationRequest } from "../../types/pages/organization";

interface OrganizationState {
    organization: Organization | null;
    loading: boolean;
    error: string | null;
    updateLoading: boolean;
    updateError: string | null;
    updateSuccess: boolean;
}

const initialState: OrganizationState = {
    organization: null,
    loading: false,
    error: null,
    updateLoading: false,
    updateError: null,
    updateSuccess: false,
};

const organizationSlice = createSlice({
    name: "organization",
    initialState,
    reducers: {
        fetchOrganization: (state) => { },
        fetchOrganizationStart: (state) => {
            state.loading = true;
            state.error = null;
        },
        fetchOrganizationSuccess: (state, action: PayloadAction<Organization>) => {
            state.loading = false;
            state.organization = action.payload;
        },
        fetchOrganizationFailure: (state, action: PayloadAction<string>) => {
            state.loading = false;
            state.error = action.payload;
        },

        updateOrganization: (state, _action: PayloadAction<UpdateOrganizationRequest>) => { },
        updateOrganizationStart: (state) => {
            state.updateLoading = true;
            state.updateError = null;
            state.updateSuccess = false;
        },
        updateOrganizationSuccess: (state, action: PayloadAction<Organization>) => {
            state.updateLoading = false;
            state.updateSuccess = true;
            state.organization = action.payload;
        },
        updateOrganizationFailure: (state, action: PayloadAction<string>) => {
            state.updateLoading = false;
            state.updateError = action.payload;
            state.updateSuccess = false;
        },
        resetUpdateState: (state) => {
            state.updateError = null;
            state.updateSuccess = false;
        }
    }
});

export const {
    fetchOrganization,
    fetchOrganizationStart,
    fetchOrganizationSuccess,
    fetchOrganizationFailure,
    updateOrganization,
    updateOrganizationStart,
    updateOrganizationSuccess,
    updateOrganizationFailure,
    resetUpdateState,
} = organizationSlice.actions;

export default organizationSlice.reducer;


